import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const CommissionPlanTemplateWaitingPeriodsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const listCommissionPlanTemplateWaitingPeriods = useCallback(async () => {
        await execute({ scope: 'list_commissionPlanTemplateWaitingPeriods', url: `CommissionPlanTemplate/CommissionPlanChangeWaitingPeriods`, method: 'GET', secure: true });
    }, [execute]);  

    const listFranchiseCommissionPlanTemplates = useCallback(async (props) => {
        await execute({ scope: 'list_franchiseCommissionPlanTemplates', url: `CommissionPlanTemplateWaitingPeriods/FranchiseCommissionPlanTemplates/${props.id}`, method: 'GET', secure: true });
    }, [execute]);  

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `CommissionPlanTemplateWaitingPeriods/GetCommissionPlanTemplateWaitingPeriod/${props.id}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `CommissionPlanTemplateWaitingPeriods/CreateCommissionPlanTemplateWaitingPeriod`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `CommissionPlanTemplateWaitingPeriods/EditCommissionPlanTemplateWaitingPeriod`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `CommissionPlanTemplateWaitingPeriods/GetCommissionPlanTemplateWaitingPeriodsByFranchiseId/${props.id}`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `CommissionPlanTemplateWaitingPeriods/DeleteCommissionPlanTemplateWaitingPeriod/${props.id}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { listCommissionPlanTemplateWaitingPeriods, listFranchiseCommissionPlanTemplates, selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useCommissionPlanTemplateWaitingPeriodsStore = () => React.useContext(Context);